module.exports = __webpack_public_path__ + "static/img/stay-option-icon-airconditioner.0b3f4a8c.svg";